import {
    FETCH_PERSONAL_RECORD_CANDIDATES,
    FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING,
    FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS,
    FETCH_PERSONAL_RECORD_CANDIDATES_FAIL,
    DELETE_PERSONAL_RECORD_CANDIDATE,
    DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS,
    DELETE_PERSONAL_RECORD_CANDIDATE_FAIL
} from 'actions/ActionTypes.js';
import { deletePersonalRecord } from './personalRecords';

const INITIAL_STATE = {
    data: [],
    personalRecordCandidatesFetching: false,
    personalRecordCandidatesFetchFail: false,
    personalRecordCandidateDeleteFail: false,
    personalRecordCandidateDeleteSuccess: false
};

// ======= Fetching Handlers =======
const fetchPersonalRecordCandidatesFetching = (state, action) => {
    return {
        ...state,
        personalRecordCandidatesFetching: true,
        personalRecordCandidatesFetchFail: false
    };
};

const fetchPersonalRecordCandidatesSuccess = (state, action) => {
    return {
        ...state,
        data: [...action.data],
        personalRecordCandidatesFetching: false,
        personalRecordCandidatesFetchFail: false
    };
};

const fetchPersonalRecordCandidatesFail = (state, action) => {
    return {
        ...state,
        personalRecordCandidatesFetching: false,
        personalRecordCandidatesFetchFail: true
    };
};

const personalRecordCandidateDeleted = (success) => (state, action) => {
    return {
        ...state,
        personalRecordCandidateDeleteSuccess: success,
        personalRecordCandidateDeleteFail: !success
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING]: fetchPersonalRecordCandidatesFetching,
    [FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS]: fetchPersonalRecordCandidatesSuccess,
    [FETCH_PERSONAL_RECORD_CANDIDATES_FAIL]: fetchPersonalRecordCandidatesFail,
    [DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS]: personalRecordCandidateDeleted(true),
    [DELETE_PERSONAL_RECORD_CANDIDATE_FAIL]: personalRecordCandidateDeleted(false)
};

// ======= Default Action ======
export default function personalRecordCandidates(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchPersonalRecordCandidates(displayName, evictCache) {
    return {
        displayName: displayName,
        type: FETCH_PERSONAL_RECORD_CANDIDATES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deletePersonalRecordCandidate(displayName, personalRecordCandidate) {
    return {
        type: DELETE_PERSONAL_RECORD_CANDIDATE,
        personalRecordCandidate,
        displayName
    };
}

export const getPersonalRecordCandidates = (state) => {
    return state.personalRecordCandidates.data ? state.personalRecordCandidates.data : null;
};

export const isPersonalRecordCandidateDeleteSuccess = (state) => {
    return state.personalRecordCandidates.personalRecordCandidateDeleteSuccess;
};

export const isPersonalRecordCandidatesFetching = (state) => {
    return state.personalRecordCandidates.personalRecordCandidatesFetching;
};
